const features = [
  {
    icon: "🏆",
    title: "Certified Authenticity",
    desc: "Every piece comes with a valid gem authenticity certificate",
  },
  {
    icon: "✦",
    title: "Custom Designs",
    desc: "We bring your unique jewellery ideas to life with expert craftsmanship",
  },
  {
    icon: "🚚",
    title: "Free Island wide Delivery",
    desc: "Complimentary secure delivery anywhere in Sri Lanka with full tracking",
  },
  {
    icon: "💎",
    title: "Lifetime Warranty",
    desc: "Every piece comes with a lifetime warranty trusted for over 25 years",
  },
];

export default features;
